export const OPENAI_API_KEY =
  "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";